import { MENU_DISPLAY_TIMING, MENU_PROPERTIES_1, MENU_PROPERTIES_2, MENU_TYPES } from 'features/MenuList/constants';
import { Menu, MenuProperty } from 'features/MenuList/models/menu';

export class MenuView {
  menu_type_id: number;
  menu_type_name: string;
  menu_display_timing_id: number;
  menu_display_timing_name: string;
  menu_properties: MenuProperty[];
  menu: Menu;
  start_date: string;
  end_date: string;
  constructor(menu: Menu, start_date = '', end_date = '') {
    const menu_type = MENU_TYPES.find((x) => x.value === menu.type);
    const menu_display_timing = MENU_DISPLAY_TIMING.find((x) => x.value === menu.default_value_display_timing);
    this.menu_type_id = menu_type?.value || -1;
    this.menu_type_name = menu_type?.display_name || '';
    this.menu_display_timing_id = menu_display_timing?.value || -1;
    this.menu_display_timing_name = menu_display_timing?.key || '';
    this.menu_properties = menu.menu_properties;
    this.menu = menu;
    this.start_date = start_date;
    this.end_date = end_date;
  }

  public properties_active() {
    const properties = [...MENU_PROPERTIES_1, ...MENU_PROPERTIES_2];
    properties.shift();
    return properties.map((prop, idx) => {
      const propertyObj = this.menu_properties.find((p) => p.property === prop.value);
      return {
        id: propertyObj?.id ?? -1,
        property: propertyObj?.property ?? prop.value,
        is_active: propertyObj?.is_active ?? false,
        //custom fields
        text: prop.key,
        sign: propertyObj?.is_active ? '〇' : 'ー',
      } as MenuProperty;
    });
  }

  public get startDate() {
    return this.start_date.toString().replaceAll('-', '/');
  }

  public get endDate() {
    return this.end_date.toString().replaceAll('-', '/');
  }
}
